import React from 'react';
import { MediaWrapper } from './MediaImage.styles';
import Image from '@/providers/Image';
import useImagePulse from '@/components/media/imagePulseHook';
import { mediaBlurDataUrl, mediaUrlCdn } from '@/utils/media';

export interface MediaImageProps {
  media: MediaObjType;
}

const MediaImage = ({ media }: MediaImageProps) => {
  const { className, containerRef, handleOnCompleted } = useImagePulse();

  return (
    <MediaWrapper className={className} ref={containerRef}>
      <Image
        src={mediaUrlCdn({ media })}
        alt={media.title}
        fill
        placeholder={mediaBlurDataUrl({ media })}
        fadeInOnBlur
        handleOnCompleted={handleOnCompleted}
      />
    </MediaWrapper>
  );
};

export default MediaImage;
